// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"214d1b12","488":"6597048b","977":"262d28d9"}[chunkId] + ".chunk.js";
};